@import '~style-sheet-helpers/core.less';
@import (reference) '../../../../constants/spacing.module.less';

.left-side {
  margin-right: auto;
}

.right-side {
  display: flex;
  gap: @space-8;
}
